import 'classlist-polyfill'
import 'promise-polyfill/src/polyfill'

import React, { FC, useState, useEffect } from 'react'
import Chart from "react-apexcharts"
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Loading from '../common/Loading'

import { LangValue } from '../../../states/types/common'
import { TeamReportLineChart } from '../../../states/types/team'

import { lineOptions } from './VariablesLineChart'
import InfoTips from '../common/InfoTips'

interface BizPointLineChartProps {
  isLoading: boolean | undefined
  lineChartData: TeamReportLineChart | undefined
}

const BizPointLineChart: FC<BizPointLineChartProps> = (props) => {
  const { t } = useTranslation()
  const { language } = useParams<{ language: LangValue }>()

  const {
    isLoading,
    lineChartData,
  } = props

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [chartData, setChartData] = useState<any>(undefined)

  useEffect(() => {
    if (!lineChartData) {
      setChartData(undefined)
      return
    }

    const chartOptions = lineOptions
    if (language === "en") {
      chartOptions.xaxis.categories = [
        "8 am", "9 am", "10 am", "11 am", "12 am", "1 pm",
        "2 pm", "3 pm", "4 pm", "5 pm", "6 pm", "7 pm",
        "8 pm", "9 pm", "10 pm", "11 pm", "12 pm", "1 am",
      ]
    } else {
      chartOptions.xaxis.categories = [
        "8時", "9時", "10時", "11時", "12時", "13時",
        "14時", "15時", "16時", "17時", "18時", "19時",
        "20時", "21時", "22時", "23時", "24時", "1時",
      ]
    }

    setChartData({
      option: {
        ...chartOptions,
        xaxis: {
          ...chartOptions.xaxis,
        },
      },
      series: lineChartData.data,
    })
  }, [lineChartData, language])

  return (
    <div style={{ marginLeft: "0.5em", marginRight: "0.5em" }}>
      <div className="box">
        <div style={{ textAlign: "center", paddingTop: "1em", paddingBottom: "1em" }}>
          <span style={{ fontWeight: "bold", fontSize: "24px", color: "#094E8D" }}>{t("parts.biz_point_line_chart.title")}</span>
        </div>
        <InfoTips>
          <>
            <div>
              チームメンバーの１時間毎の操作量を表示しています
            </div>
          </>
        </InfoTips>
        <div className="box-body no-padding">
          {
            (isLoading || !chartData) ? (
              <Loading />
            ) : (
              <>
                <Chart
                  options={chartData.option}
                  type="line"
                  series={chartData.series}
                  height="350px"
                />
              </>
            )
          }
        </div>
      </div>
    </div>
  )
}

export default BizPointLineChart
